





















import { Vue, Component, Prop } from 'vue-property-decorator';
import { JotFormBlockViewModel } from '@/types/contentServerContract';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';

@Component({
    components: { SmartHeadline }
})
export default class JotFormBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: JotFormBlockViewModel;

    @Prop({
        required: false,
        type: Boolean,
        default: false
    }) isFirstBlock!: boolean;

    get jotformSrc() {
        return `https://form.jotform.com/${this.content.jotFormId}`;
    }

    $refs!: {
        jotform: any
    }

    mounted() {
        window.addEventListener('message', this.handleIFrameMessage, false);
    }

    beforeDestroy() {
        window.removeEventListener('message', this.handleIFrameMessage);
    }

    handleIFrameMessage(e: any) {
        if (typeof e.data === 'object') { return; }

        const iframe = this.$refs.jotform;
        if (!iframe) { return; }

        const args = e.data.split(':');

        const _window = window as any;

        switch (args[0]) {
        case 'scrollIntoView':
            if (this.isFirstBlock) { iframe.scrollIntoView(); }
            break;
        case 'setHeight':
            iframe.style.height = `${args[1]}px`;
            break;
        case 'collapseErrorPage':
            if (iframe.clientHeight > window.innerHeight) {
                iframe.style.height = `${window.innerHeight}px`;
            }
            break;
        case 'loadScript':
            {
                let src = args[1];
                if (args.length > 3) {
                    src = args[1] + ':' + args[2];
                }
                const script = document.createElement('script');
                script.src = src;
                script.type = 'text/javascript';
                document.body.appendChild(script);
            }
            break;
        case 'exitFullscreen':
            if (_window.document.exitFullscreen) _window.document.exitFullscreen();
            else if (_window.document.mozCancelFullScreen) _window.document.mozCancelFullScreen();
            else if (_window.document.mozCancelFullscreen) _window.document.mozCancelFullScreen();
            else if (_window.document.webkitExitFullscreen) _window.document.webkitExitFullscreen();
            else if (_window.document.msExitFullscreen) _window.document.msExitFullscreen();
            break;
        }
        const isJotForm = (e.origin.indexOf('jotform') > -1);
        if (isJotForm && 'contentWindow' in iframe && 'postMessage' in iframe.contentWindow) {
            const urls = { docurl: encodeURIComponent(document.URL), referrer: encodeURIComponent(document.referrer) };
            iframe.contentWindow.postMessage(JSON.stringify({ type: 'urls', value: urls }), '*');
        }
    }
}
